import { render, staticRenderFns } from "./HowItWorksVertical.vue?vue&type=template&id=009a4c68&"
import script from "./HowItWorksVertical.vue?vue&type=script&lang=js&"
export * from "./HowItWorksVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports